module.exports = __webpack_public_path__ + "static/media/stage2.2bdba392.jpg";